// How long something has waited for the events team: "under an hour", "3 hours", "1 day", "4 days".
export function fmtWaiting(at, now = new Date()) {
  const hours = Math.floor((now - new Date(at)) / 3600_000);
  if (hours < 1) return "under an hour";
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"}`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? "" : "s"}`;
}
